"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.authShape = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("./constants");
/* eslint-disable import/prefer-default-export */
var authShape = exports.authShape = _propTypes.default.shape({
  client: _propTypes.default.object,
  status: _propTypes.default.oneOf([_constants.AUTH_STATUS_UNAUTHENTICATED, _constants.AUTH_STATUS_AUTHENTICATING, _constants.AUTH_STATUS_AUTHENTICATED]).isRequired,
  error: _propTypes.default.object,
  session: _propTypes.default.object,
  profile: _propTypes.default.object
});